import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('g', { id: 'Artboard-32' }),
  React.createElement('path', { d: 'M16,3.72A12.28,12.28,0,1,0,28.28,16,12.3,12.3,0,0,0,16,3.72ZM16,27A11,11,0,1,1,27,16,11,11,0,0,1,16,27Z' }),
  React.createElement('rect', { x: '9.84', y: '15.35', width: '12.32', height: '1.3' })
));